import React from 'react';
type Tone = 'light' | 'dark';
export function Eyebrow({
  children,
  tone = 'light',
  align = 'center'
}: {
  children: React.ReactNode;
  tone?: Tone;
  align?: 'center' | 'left';
}) {
  return <p className={`mb-2 font-display text-[11px] font-extrabold uppercase tracking-[.18em] md:text-xs ${align === 'center' ? 'text-center' : 'text-left'} ${tone === 'dark' ? 'text-brand-light' : 'text-brand'}`} data-id="element-237" data-mp="2vxarwwrr3qtv">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <h2 className={`mx-auto max-w-4xl text-center font-display text-xl font-black uppercase leading-tight md:text-3xl ${tone === 'dark' ? 'text-white' : 'text-navy'}`} data-id="element-238" data-mp="3evn5cupp3mv9">
      {children}
    </h2>;
}
export function SectionLead({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <p className={`mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed md:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-steel'}`} data-id="element-239" data-mp="1ggivq1qyfu0t">
      {children}
    </p>;
}
export function Mark({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="bg-brand-light/25 box-decoration-clone px-1.5 text-navy" data-id="element-240" data-mp="29i05s053otkc">{children}</span>;
}